import styled from 'styled-components';
import { ExpandingContainer } from '../ExpandingContainer/ExpandingContainer';
import { Typography, TypographyStyledAs } from '../Typography/Typography';

const StyledErrorMessage = styled(Typography)`
  color: var(--red-400);
`;

export interface ErrorMessageProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  // `true` by default
  visible?: boolean;
  // The space between the margin and the button/input/etc above it
  // This is animated in with the height of the error message
  // so it's revealed smoothly and there's no unnecessary whitespace
  // when the error message is hidden
  marginTop?: string;
  textStyledAs?: TypographyStyledAs;
  marginBottom?: string;
}

/**
 * A component for displaying error messages.
 *
 * The message is colored red and will animate in when mounted. If you set the `visible` prop to `false` remove the error message, it will also animate out.
 */
export const ErrorMessage = ({
  children,
  marginTop = '4px',
  marginBottom = '0px',
  textStyledAs = 'bodyDMSans',
  ...rest
}: ErrorMessageProps) => {
  return (
    <ExpandingContainer marginTop={marginTop} {...rest}>
      <StyledErrorMessage weight={500} styledAs={textStyledAs} marginBottom={marginBottom}>
        {children}
      </StyledErrorMessage>
    </ExpandingContainer>
  );
};
